import React from 'react';
import {
  Router,
  Route,
  IndexRedirect,
  IndexRoute,
  browserHistory,
  Redirect
} from 'react-router';

import App from './app';
import Loading from '_shared/components/loading';
import VerificationError from './app/components/verificationError';
import GoogleCallback from './app/components/googleCallback';
import Signup from './app/components/signup';
import ProductSignup from './app/components/signup/productSignup';
import OtherSignup from './app/components/signup/otherSignup';
import ThankYou from './app/components/thankYou';
import ThankYouOther from './app/components/thankYou/other';
import Terms from './app/components/terms';
import CreateAccount from './app/components/createAccount';
import Login from './app/components/login';
import NoAuth from './app/components/noAuth';
import Products from './app/components/products';
import AdminEmail from './app/components/adminEmail';
import Begin from './app/components/gettingStarted/begin';
import SignIn from './app/components/gettingStarted/signIn';
import Navigate from './app/components/gettingStarted/navigate';
import Select from './app/components/gettingStarted/select';
import Deploy from './app/components/gettingStarted/deploy';
import Finish from './app/components/gettingStarted/finish';
import End from './app/components/gettingStarted/end';
import SurveyStart from './app/components/survey/start';
import SurveyQuestions from './app/components/survey/questions';
import SurveyEnd from './app/components/survey/end';
import {trackPages} from './_shared/lib/page-tracker';
import NoGACSignup from './app/components/noGACSignup';

/**
 * Track all page changes with analytics.
 */
trackPages(browserHistory);

export default (
  <Router history={browserHistory}>
    <Route path="/" component={App}>
      <IndexRedirect to="role" />
      <Route path="loading" component={Loading} />
      <Route path="thank-you" component={ThankYou} />
      <Route path="thank-you-other" component={ThankYouOther} />
      <Route path="terms" component={Terms} />
      <Route path="google/error" component={VerificationError} />
      <Route path="google/callback" component={GoogleCallback} />
      <Route path="role" component={Signup} />
      <Route path="product/:product" component={ProductSignup} />
      <Route path="other" component={OtherSignup} />
      <Redirect from="signup/:product" to="product/:product" />
      <Route path="no-auth" component={NoAuth} />
      <Route path="create-account" component={CreateAccount} />
      <Route path="login" component={Login} />
      <Route path="products" component={Products} />
      <Route path="admin-email" component={AdminEmail} />
      <Route path="survey">
        <Route path="start" component={SurveyStart} />
        <Route path="questions" component={SurveyQuestions} />
        <Route path="end" component={SurveyEnd} />
      </Route>
      <Route path="getting-started">
        <IndexRoute component={Begin}/>
        <Route path="begin" component={Begin} />
        <Route path="sign-in" component={SignIn} />
        <Route path="navigate" component={Navigate} />
        <Route path="select" component={Select} />
        <Route path="deploy" component={Deploy} />
        <Route path="finish" component={Finish} />
        <Route path="end" component={End} />
      </Route>
      <Route path="no-gac" component={NoGACSignup} />
    </Route>
  </Router>
);



/** WEBPACK FOOTER **
 ** ./src/routes.jsx
 **/